import { ModulesCrossSellingModule, ModulesDatoModule } from 'generated/resources/datatable.graphql'

import { useModuleAvailabilities } from 'modules/core/hooks/useModuleAvailabilities'

import { countryCode } from 'modules/marketplace_modules/components/utils/countryCode'

export const useGetAvailableModules = (
  crossSellingModules: (ModulesDatoModule | ModulesCrossSellingModule)[] | undefined | null,
  mainCountry: string
) => {
  const { moduleAvailabilities } = useModuleAvailabilities()
  if (!crossSellingModules) return []

  // get all modules with global country
  const globalModules = crossSellingModules?.filter((crossSellingModule) =>
    crossSellingModule.countries?.find((country) => country.countryCode == 'global')
  )

  // get all modules with main legal entity country
  const countryModules = crossSellingModules.filter((crossSellingModule) =>
    crossSellingModule.countries?.find(
      (country) => country.countryCode === countryCode(mainCountry)
    )
  )

  const modulesAvailableInCountry =
    countryModules.length > 0 ? [...new Set([...countryModules, ...globalModules])] : globalModules

  const uninstalledModuleIds = moduleAvailabilities
    .filter((mod) => !mod.available)
    .map((mod) => mod.id)

  const uninstalledCrossSellingModules = modulesAvailableInCountry.filter((mod) =>
    uninstalledModuleIds.includes(mod.chargebeeModuleName || '')
  )

  return uninstalledCrossSellingModules
}
